import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { CustomButton } from "../CustomButton";
import AINavigation from "./AINavigation";
import ConfigureAI from "./ConfigureAI";
import SourceUpload from "./SourceUpload";
import StartFlow from "./StartFlow";
import { useDispatch, useSelector } from "react-redux";
import {
  registerCompany,
  stopAIService,
  startAIService,
  checkCompanyRegistration,
  updateAICompany,
} from "../../reducers/aiSlice";
import "./index.css";
const AIbotDialog = ({ visible, onHide }) => {
  const { isLoading } = useSelector((state) => state.ai);
  const dispatch = useDispatch();

  const [registrationForm, setRegistrationForm] = useState({
    companySector: "",
    aiFeature: "",
  });
  const [uploadedFile, setUploadedFile] = useState([]);
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(1);
  const [renderComponetn, setRenderComponent] = useState(<ConfigureAI />);
  const [botFlowStatus, setBotFlowStatus] = useState("");
  const tabs = [
    { label: "Configure AI Feature", value: 1 },
    { label: "Upload Or Input Source", value: 2 },
    { label: "Start Your AI Flow", value: 3 },
  ];

  const checkStatus = async () => {
    try {
      const registrationResult = await dispatch(
        checkCompanyRegistration()
      ).unwrap();
      if (registrationResult) {
        setRegistrationForm({
          companySector: registrationResult.companySector,
          aiFeature: registrationResult.aiFeature,
        });
        setBotFlowStatus(registrationResult?.botStatus);
        if (registrationResult?.botStatus === "ACTIVE") {
          setActiveTab(3);
        }
      }
    } catch (err) {
      setError(err.message || "An error occurred while checking status");
      setActiveTab(1);
    }
  };
  useEffect(() => {
    checkStatus();
    setUploadedFile([]);
    setUrl(null);
    setError(null);
  }, [visible, dispatch]);

  const handleRegistrationSubmit = async () => {
    try {
      await dispatch(registerCompany(registrationForm)).unwrap();
      setError(null);
      setActiveTab(activeTab + 1);
    } catch (err) {
      setError(err.message || "Registration failed");
    }
  };

  const handleStartService = async () => {
    if (!uploadedFile && !url) return;
    try {
      await dispatch(startAIService({ files: uploadedFile, url })).unwrap();
      setActiveTab(3);
      checkStatus();
      setUrl(null);
      setUploadedFile(null);
    } catch (err) {
      setError(err.message || "Failed to start AI service");
    }
  };

  const handleStopService = async () => {
    try {
      await dispatch(stopAIService()).unwrap();
      setActiveTab(2);
      checkStatus();
      setUrl(null);
      setUploadedFile(null);
    } catch (err) {
      setError(err.message || "Failed to stop AI service");
    }
  };
  const handleCompanyUpdateSubmit = async () => {
    try {
      await dispatch(updateAICompany(registrationForm)).unwrap();
      setError(null);
      setActiveTab(activeTab + 1);
      checkStatus();
    } catch (err) {
      setError(err.message || "Failed to update company botconfiguration");
    }
  };

  const handleNext = () => {
    switch (activeTab) {
      case 1:
        if (
          (registrationForm?.aiFeature == "",
          registrationForm?.companySector == "")
        ) {
          handleRegistrationSubmit();
        } else {
          handleCompanyUpdateSubmit();
        }
        break;
      case 2:
        setActiveTab(activeTab + 1);
        break;
    }
  };

  useEffect(() => {
    switch (activeTab) {
      case 1:
        setRenderComponent(
          <ConfigureAI
            registrationForm={registrationForm}
            setRegistrationForm={setRegistrationForm}
          />
        );
        break;
      case 2:
        setRenderComponent(
          <SourceUpload
            uploadedFile={uploadedFile}
            setUrl={setUrl}
            url={url}
            setUploadedFile={setUploadedFile}
            onSubmit={handleStartService}
          />
        );
        break;
      case 3:
        setRenderComponent(
          <StartFlow
            registrationForm={registrationForm}
            botFlowStatus={botFlowStatus}
          />
        );
        break;
      default:
        setRenderComponent(<ConfigureAI />);
    }
  }, [activeTab, url, uploadedFile, botFlowStatus]);

  return (
    <div className="flex justify-center items-center h-screen">
      <Dialog
        visible={visible}
        onHide={onHide}
        dismissableMask={false}
        closable={false}
        style={{ width: "65vw", minHeight: "90vh" }}
        draggable={false}
        header={
          <div
            className=""
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <div>Create AI Flow</div>

            <div className="flex items-center gap-2">
              <CustomButton
                label="Cancel"
                varient="cancel"
                autofocus={true}
                onClick={onHide}
              />
              {activeTab < 3 && (
                <CustomButton
                  label={"Next"}
                  varient="filled"
                  onClick={handleNext}
                  disabled={isLoading}
                />
              )}
              {botFlowStatus === "ACTIVE" && activeTab === 3 && (
                <CustomButton
                  label="Stop AI"
                  varient="filled"
                  onClick={handleStopService}
                  disabled={isLoading}
                />
              )}
              {botFlowStatus === "CLOSED" && activeTab === 3 && (
                <CustomButton
                  label="Start AI"
                  varient="filled"
                  onClick={handleStartService}
                  disabled={isLoading}
                />
              )}
            </div>
          </div>
        }
      >
        <div>
          <div className="navigation_ai_bot">
            <AINavigation
              navtabs={tabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>
          <div className="ai_main_container"> {renderComponetn} </div>
        </div>
      </Dialog>
    </div>
  );
};

export default AIbotDialog;
